/** O Quill deixa `<p><br></p>` e `&nbsp;` num editor "vazio": sem as tags, não sobra texto. */
export const isRichTextEmpty = (html: string | null | undefined): boolean =>
  !html ||
  html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, '')
    .trim() === ''
